// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_uY0","tabsBox":"styles_tabsBox__3s3CX","createButton":"styles_createButton__SLq-2"};